// Plan de l'Admin : 4 groupes, une route par section (refonte de l'Admin, phase 1).
// Fichier PUR (aucun React) : le menu, le routage et la memoire de la derniere section en dependent, et il se teste seul.

export const ADMIN_BASE = '/admin';

// `alert` : cle de /api/admin/alerts dont la valeur (> 0) allume une pastille rouge sur l'entree du menu.
export const ADMIN_GROUPS = [
  {
    key: 'pilot',
    items: [
      { key: 'dashboard', path: 'tableau-de-bord', icon: 'home' },
      { key: 'orders', path: 'commandes', icon: 'bag', alert: 'failedOrders' },
      { key: 'books', path: 'livres', icon: 'book' },
      { key: 'users', path: 'utilisateurs', icon: 'users' }
    ]
  },
  {
    key: 'catalog',
    items: [
      { key: 'providers', path: 'fournisseurs', icon: 'truck' },
      { key: 'products', path: 'produits', icon: 'box' },
      { key: 'pricing', path: 'tarifs', icon: 'tag' }
    ]
  },
  {
    key: 'site',
    items: [
      { key: 'traffic', path: 'trafic', icon: 'chart', alert: 'newVisits' },
      { key: 'operations', path: 'exploitation', icon: 'server', alert: 'incident' },
      { key: 'emails', path: 'e-mails', icon: 'mail' }
    ]
  },
  {
    key: 'settings',
    items: [
      { key: 'mode', path: 'reglages', icon: 'gear' }
    ]
  }
];

export const ADMIN_ITEMS = ADMIN_GROUPS.flatMap((groupe) => groupe.items);
export const DEFAULT_ADMIN_KEY = 'dashboard';

export const adminPath = (key) => {
  const item = ADMIN_ITEMS.find((candidat) => candidat.key === key) || ADMIN_ITEMS.find((candidat) => candidat.key === DEFAULT_ADMIN_KEY);
  return `${ADMIN_BASE}/${item.path}`;
};

/** « /admin/commandes/ » -> « orders » ; null si ce n'est pas une section connue. */
export const adminKeyFromPathname = (pathname) => {
  const segment = String(pathname || '').replace(/^\/admin\/?/, '').split('/')[0];
  const item = ADMIN_ITEMS.find((candidat) => candidat.path === segment);
  return item ? item.key : null;
};

// --- Derniere section visitee (stockage local, avec repli si indisponible : navigation privee, stockage bloque...) ----------
const CLE_DERNIERE_SECTION = 'bookipix.admin.derniereSection';

export const lireDerniereSection = () => {
  try {
    const valeur = window.localStorage.getItem(CLE_DERNIERE_SECTION);
    return ADMIN_ITEMS.some((item) => item.key === valeur) ? valeur : null;
  } catch (_erreur) {
    return null;
  }
};

export const memoriserDerniereSection = (key) => {
  try {
    if (ADMIN_ITEMS.some((item) => item.key === key)) window.localStorage.setItem(CLE_DERNIERE_SECTION, key);
  } catch (_erreur) { /* sans stockage : on repart du tableau de bord, rien de grave */ }
};
